import { Pipe, PipeTransform } from '@angular/core';

/**
 * Forces a Google Cloud Storage signed url to be served as an inline mp4.
 *
 * Signed urls come back with `content-type: application/octet-stream` and
 * `content-disposition: attachment`. iOS WKWebView picks the media decoder from
 * Content-Type only and fails with MEDIA_ERR_SRC_NOT_SUPPORTED (code 4).
 * GCS honours the `response-*` query overrides without a new signature.
 */
@Pipe({
    name: 'inlineVideoUrl',
    standalone: false
})
export class InlineVideoUrlPipe implements PipeTransform {

  transform(url: string): string {
    if (!url || typeof url !== 'string') { return url }
    if (!url.startsWith('http')) { return url }
    if (url.indexOf('storage.googleapis.com') < 0) { return url }
    if (url.indexOf('response-content-type=') >= 0) { return url }

    // Keep any media fragment (e.g. #t=10,20) after the query string.
    const hashIndex = url.indexOf('#')
    const base = hashIndex >= 0 ? url.slice(0, hashIndex) : url
    const fragment = hashIndex >= 0 ? url.slice(hashIndex) : ''

    let result = base + (base.indexOf('?') >= 0 ? '&' : '?') + 'response-content-type=video%2Fmp4'
    if (base.indexOf('response-content-disposition=') < 0) {
      result += '&response-content-disposition=inline'
    }
    return result + fragment
  }
}
